// import { InfoCircle } from "../../../../../components";

// const InfoCircleList = () => {
//   return (
//     <div className="flex flex-col pt-8 pl-2 gap-8">
//       <div className="flex items-center gap-8">
//         <InfoCircle
//           backgroundColor="primary"
//           colorShade="50"
//           border="outlined"
//           size="xs"
//         />
//         <InfoCircle
//           backgroundColor="success"
//           colorShade="50"
//           border="outlined"
//           size="xs-sm"
//         />
//         <InfoCircle
//           backgroundColor="info"
//           colorShade="50"
//           border="outlined"
//           size="sm"
//         />
//         <InfoCircle backgroundColor="warning" colorShade="500" />
//         <InfoCircle backgroundColor="danger" colorShade="400" size="lg" />
//         <InfoCircle backgroundColor="gray" colorShade="800" size="xl" />
//       </div>
//       <div className="flex items-center gap-8">
//         <InfoCircle
//           value="9"
//           textColor="black"
//           backgroundColor="primary"
//           colorShade="50"
//           border="outlined"
//           size="xs"
//         />
//         <InfoCircle
//           value="8"
//           backgroundColor="success"
//           colorShade="50"
//           border="outlined"
//           size="xs-sm"
//         />
//         <InfoCircle
//           value="1"
//           backgroundColor="info"
//           colorShade="50"
//           border="outlined"
//           size="sm"
//         />
//         <InfoCircle
//           value="5"
//           backgroundColor="warning"
//           colorShade="500"
//           textColor="white"
//         />
//         <InfoCircle
//           value="7"
//           backgroundColor="danger"
//           colorShade="400"
//           textColor="white"
//           size="lg"
//         />
//         <InfoCircle
//           value="6"
//           backgroundColor="gray"
//           colorShade="800"
//           size="xl"
//           textColor="white"
//         />
//       </div>
//       <div className="flex items-center gap-8">
//         <InfoCircle
//           value="+9"
//           textColor="black"
//           backgroundColor="primary"
//           colorShade="50"
//           border="outlined"
//           size="xs"
//         />
//         <InfoCircle
//           value="+8"
//           backgroundColor="success"
//           colorShade="50"
//           border="outlined"
//           size="xs-sm"
//         />
//         <InfoCircle
//           value="+1"
//           backgroundColor="info"
//           colorShade="50"
//           border="outlined"
//           size="sm"
//         />
//         <InfoCircle
//           value="+5"
//           backgroundColor="warning"
//           colorShade="500"
//           textColor="white"
//         />
//         <InfoCircle
//           value="+7"
//           backgroundColor="danger"
//           colorShade="400"
//           textColor="white"
//           size="lg"
//         />
//         <InfoCircle
//           value="+6"
//           backgroundColor="gray"
//           colorShade="800"
//           size="xl"
//           textColor="white"
//         />
//       </div>
//       <div className="flex items-center gap-8">
//         <InfoCircle
//           value="999"
//           textColor="black"
//           backgroundColor="primary"
//           colorShade="50"
//           border="outlined"
//           size="xs"
//         />
//         <InfoCircle
//           value="888"
//           backgroundColor="success"
//           colorShade="50"
//           border="outlined"
//           size="xs-sm"
//         />
//         <InfoCircle
//           value="1234"
//           backgroundColor="info"
//           colorShade="50"
//           border="outlined"
//           size="sm"
//         />
//         <InfoCircle
//           value="+591"
//           backgroundColor="warning"
//           colorShade="500"
//           textColor="white"
//         />
//         <InfoCircle
//           value="754"
//           backgroundColor="danger"
//           colorShade="400"
//           size="lg"
//           textColor="white"
//         />
//         <InfoCircle
//           value="656"
//           backgroundColor="gray"
//           colorShade="800"
//           size="xl"
//           textColor="white"
//         />
//       </div>
//       <div className="flex items-center gap-8">
//         <InfoCircle
//           value="+9999"
//           textColor="black"
//           backgroundColor="primary"
//           colorShade="50"
//           border="outlined"
//           size="xs"
//         />
//         <InfoCircle
//           value="+9888"
//           backgroundColor="success"
//           colorShade="50"
//           border="outlined"
//           size="xs-sm"
//         />
//         <InfoCircle
//           value="+2830"
//           backgroundColor="info"
//           colorShade="50"
//           border="outlined"
//           size="sm"
//         />
//         <InfoCircle
//           value="+5910"
//           backgroundColor="warning"
//           colorShade="500"
//           textColor="white"
//         />
//         <InfoCircle
//           value="+0754"
//           backgroundColor="danger"
//           colorShade="400"
//           size="lg"
//           textColor="white"
//         />
//         <InfoCircle
//           value="+0656"
//           backgroundColor="gray"
//           colorShade="800"
//           size="xl"
//           textColor="white"
//         />
//       </div>
//     </div>
//   );
// };

// export default InfoCircleList;

// import React from 'react'

// const InfoCircleList = () => {
//   return (
//     <div>InfoCircleList</div>
//   )
// }

// export default InfoCircleList

import React from "react";
import { Avatar, InfoCircle } from "../../../../../components";

const InfoCircleList = () => {
  const sizeList = [
    "xs",
    "xs-sm",
    "sm",
    "md",
    "lg",
    "xl",
    "xxl",
    "3xl",
    "4xl",
    "5xl",
  ];
  const colorList = [
    "primary",
    "warning",
    "success",
    "danger",
    "info",
    "draft",
    "invoiced",
    "leave",
  ];
  const colorDepthList = [
    "50",
    "100",
    "200",
    "300",
    "400",
    "500",
    "600",
    "700",
    "800",
    "900",
  ];
  const variantList = ["contained", "outlined"];
  const noBorderList = [true, false];
  const prefixList = ["+", "-", ""];
  //need some random values array dynamically like [9,12,55,485,4578,23.........] 40 random values
  const valueList = [
    9, 12, 55, 485, 4578, 23, 456, 789, 1000, 1234, 5678, 9750, 10022, 15125,
    20000, 252486, 23759, 35871, 40560,
  ];

  return (
    <div className="w-full my-4 flex flex-col gap-3">
      <div className="flex gap-2 items-center flex-wrap">
        {sizeList.map((size) => (
          <div key={size}>
            <InfoCircle
              key={size}
              value={50}
              size={size}
              prefix={prefixList[Math.floor(Math.random() * prefixList.length)]}
            />
          </div>
        ))}
      </div>
      <div className="flex gap-2 items-center flex-wrap">
        {colorList.map((color) => {
          return (
            <div key={color} className="flex gap-1">
              {colorDepthList.map((depth) => {
                return (
                  <div key={depth} className="flex gap-1">
                    <InfoCircle
                      key={`${color}-${depth}`}
                      value={
                        valueList[Math.floor(Math.random() * valueList.length)]
                      }
                      prefix={
                        prefixList[
                          Math.floor(Math.random() * prefixList.length)
                        ]
                      }
                      color={color}
                      colorDepth={depth}
                    />
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
      <div className="flex flex-col gap-2">
        {variantList.map((variant) => {
          return (
            <div key={variant} className="flex gap-2">
              {colorList.map((color) => {
                return (
                  <div key={color} className="flex gap-2">
                    <InfoCircle
                      key={`${variant}-${color}`}
                      value={
                        valueList[Math.floor(Math.random() * valueList.length)]
                      }
                      color={color}
                      variant={variant}
                      prefix={
                        prefixList[
                          Math.floor(Math.random() * prefixList.length)
                        ]
                      }
                    />
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
      <div>
        {noBorderList.map((noBorder) => {
          return (
            <div key={noBorder} className="flex gap-2">
              <InfoCircle
                key={`${noBorder}`}
                value={valueList[Math.floor(Math.random() * valueList.length)]}
                prefix={
                  prefixList[Math.floor(Math.random() * prefixList.length)]
                }
                noBorder={noBorder}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default InfoCircleList;
